import { ApiClient } from '../ApiClient';

export class RoleAPI {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  // Get all roles
  async getAllRoles() {
    return this.apiClient.get('/api/v1/roles');
  }

  // Get role by ID
  async getRoleById(roleId) {
    return this.apiClient.get(`/api/v1/roles/${roleId}`);
  }

  // Create new role
  async createRole(roleData) {
    return this.apiClient.post('/api/v1/roles', roleData);
  }

  // Update role
  async updateRole(roleId, roleData) {
    return this.apiClient.put(`/api/v1/roles/${roleId}`, roleData);
  }

  // Delete role
  async deleteRole(roleId) {
    return this.apiClient.delete(`/api/v1/roles/${roleId}`);
  }

  // Get all permissions
  async getAllPermissions() {
    return this.apiClient.get('/api/v1/permissions');
  }

  // Attach roles to user type
  async attachRolesToUserType(data) {
    return this.apiClient.post('/api/v1/user-types/attach-roles', data);
  }

  // Detach roles from user type
  async detachRolesFromUserType(data) {
    return this.apiClient.post('/api/v1/user-types/detach-roles', data);
  }

  // Get roles by user type ID
  async getRolesByUserTypeId(userTypeId) {
    return this.apiClient.get(`/api/v1/user-types/${userTypeId}/roles`);
  }
}
